import * as React from 'react';
import { useSelector } from 'react-redux';

import { Agents } from '../../components/Agents';
import { getBuilders, getSellers } from '../../selectors/newbuilding';

export function AgentsContainer() {
  const sellers = useSelector(getSellers);
  const builders = useSelector(getBuilders);

  const isAnyActiveBuilder = builders.some(builder => builder.showPhone && builder.phone?.number);

  if (sellers.length === 0) {
    return null;
  }

  return <Agents sellers={sellers} title={isAnyActiveBuilder ? 'Дополнительные продавцы' : 'Кто продаёт квартиры'} />;
}
